import { filterByDocumentCreationStatus, normalizeDocumentListParams } from "helpers/documentLists";
import { OdataFilters, queryParams } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/documents/universalTransferDocuments";
const truckingBidsResource = "api/truckingbids";
const compactParams = (params: { [key: string]: unknown }) =>
    Object.keys(params).reduce(
        (acc, key) => {
            const value = params[key];
            return value === undefined || value === null || value === "" ? acc : { ...acc, [key]: value };
        },
        {} as { [key: string]: unknown },
    );

const normalizeUniversalTransferDocumentListItem = (item: { [key: string]: any }) => ({
    ...item,
    documentExists: !!item.id,
});

const toListPayload = <T extends { documentExists?: boolean }>(items: T[], documentCreationStatus?: string) => {
    const data = filterByDocumentCreationStatus(items, documentCreationStatus);

    return { data, count: data.length };
};

export const index = ({
    startedAt,
    endedAt,
    documentCreationStatus,
}: OdataFilters & { startedAt?: string; endedAt?: string; documentCreationStatus?: string }) => {
    const listParams = normalizeDocumentListParams({ startedAt, endedAt, documentCreationStatus });
    const query = queryParams(compactParams({ startedAt: listParams.startedAt, endedAt: listParams.endedAt }));

    return request(`${resource}/getList${query}`, { method: "GET" }).then((res) =>
        toListPayload((res || []).map(normalizeUniversalTransferDocumentListItem), listParams.documentCreationStatus),
    );
};

export const getItem = (id: number | string) => request(`${resource}/get/${id}`, { method: "GET" });

export const editItem = (params: {}) => alertRequest(`${resource}/edit`, body(params));

export const regenerate = (params: {}) => alertRequest(`${resource}/regenerate`, body(params));

export const createByRegistry = (params: {}) => alertRequest(`${resource}/createByRegistry`, body(params));

export const createTaxInvoice = (params: {}) => alertRequest(`${resource}/createTaxInvoice`, body(params));

export const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export const createUniversalTransferDocument = (params: {}) =>
    alertRequest(`${truckingBidsResource}/createUniversalTransferDocument`, body(params));

export const getBidsForRegistry = (params: { [key: string]: unknown }) =>
    request(`${truckingBidsResource}/getListForRegistry${queryParams(compactParams(params))}`, { method: "GET" });
